import theme from 'foundations/theme';
import {
    passwordStrengthDetail,
    WEAK_PASSWORD,
    PASSWORD_NOT_STRONG,
    STRONG_PASSWORD,
} from 'components/emailAuth/constants';

export const EMAIL_SCREEN = 'email';
export const OTP_SCREEN = 'otp';
export const OTP_APP_SUMO_SCREEN = 'otpAppSumo';
export const PASSWORD_SCREEN = 'password';
export const PASSWORD_APP_SUMO_SCREEN = 'passwordAppSumo';
export const FORGOT_PASSWORD_SCREEN = 'forgotPassword';
export const RESET_PASSWORD_SCREEN = 'resetPassword';
export const LOGIN_PASSWORD_SCREEN = 'loginPassword';
export const SSO_LOGIN_SCREEN = 'ssoLogin';
export const ACCOUNT_EMAIL_LINKING_UNAVAILABLE_SCREEN =
    'accountEmailLinkingUnavailable';
export const POST_FIRST_SIGNUP = 'postFirstSignup';
export const UNIFIED_FLOW = 'unified';
export const AUTH_COMPLETE = 'done';
export const LOGIN_FLOW = 'LOGIN';
export const SIGNUP_FLOW = 'SIGNUP';
export const COMPLETION_FLOW = 'complete';
export const SSO_FLOW = 'sso_flow';
export const APPLE_AUTH_ERROR_MESSAGE =
    'Please connect an email address in your Apple account settings or use another way to sign in.';
export const EVENT_LANDING_PATH = '/e/';
export const SIGNUP_PAGE_PATH = '/signin';
export const SWITCH_ACCOUNT_ID = 'switch';
export const INVALID_TOKEN_ID = 'invalid';
export const EXPIRED_TOKEN_ID = 'expired';
export const INVITE_FLOW_SOURCE = 'MEMBER_INVITATION';
export const PASSWORD_NOT_STRONG_ENOUGH = 'Password is not strong enough';
export const BTN_DISABLE_STYLE = {
    background: theme.colors.ambience[19],
};
export const BTN_DISABLE_TEXT_STYLE = {
    color: theme.colors.ambience[14],
};
export const L1_SCREEN = 'l1';

export const SIGNIN_REFERRER = 'signup_referrer';

export const STEP_ROUTE_MAPPING = {
    [OTP_SCREEN]: 'otp',
    [OTP_APP_SUMO_SCREEN]: 'otp',
    [EMAIL_SCREEN]: 'auth',
    [PASSWORD_SCREEN]: 'email_signup',
    [LOGIN_PASSWORD_SCREEN]: 'enterpwd',
    [FORGOT_PASSWORD_SCREEN]: 'forgotpwd',
    [RESET_PASSWORD_SCREEN]: 'resetpwd',
    [SSO_LOGIN_SCREEN]: 'ssologin',
    [POST_FIRST_SIGNUP]: 'oauth_signup',
    [ACCOUNT_EMAIL_LINKING_UNAVAILABLE_SCREEN]: 'apple_error',
};

export const getStepRouteMapping = ({ authStep, isOrganiser }) => {
    return `${SIGNUP_PAGE_PATH}/${!isOrganiser ? 'as_' : ''}${
        STEP_ROUTE_MAPPING[authStep]
    }`;
};
export const showPasswordStrength = (isValidPassword, isCharSequenced) => {
    let passwordStrength = {};
    if (!isValidPassword) {
        passwordStrength = passwordStrengthDetail[PASSWORD_NOT_STRONG];
    } else if (isValidPassword && isCharSequenced) {
        passwordStrength = passwordStrengthDetail[WEAK_PASSWORD];
    } else {
        passwordStrength = passwordStrengthDetail[STRONG_PASSWORD];
    }
    return passwordStrength;
};
